import {
    clickBackToCarrier,
    clickPlan,
    recordNumberOfPlansDisplayed,
} from '../ScanCardActions';
import { getScanCardState } from '../../../data/scan-card/scanCardSelector';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { ScanCardPlanView } from './ScanCardPlanView';

export function mapStateToProps(state) {
    const cardState = getScanCardState(state);

    let plans = [];
    const selectedCarrier = get(cardState, 'selectedInsurance.carrier'); // { id, name }
    const allCarriers = cardState.predictions;

    if (selectedCarrier) {
        plans = get(cardState, 'selectedInsurance.plans', []);
    } else if (allCarriers) {
        ({ plans } = allCarriers[0]);
    }

    return {
        ...cardState,
        plans,
    };
}

export const mapDispatchToProps = {
    clickPlan,
    clickBackToCarrier,
    recordNumberOfPlansDisplayed,
};


export const ScanCardPlanConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(ScanCardPlanView);
